(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abc-product"]) return;
  try {
    
  class AbcProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.abcp__form');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.variants = this.parseVariants();
      this.moneyFormat = window.abcpMoneyFormat || '';

      this.bindPills();
      this.bindQty();
      this.bindThumbs();
      this.bindShare();
      this.bindAddToCart();
    }

    parseVariants() {
      const el = document.querySelector('[data-abcp-variants="' + this.dataset.sectionId + '"]')
        || this.parentElement.querySelector('[data-abcp-variants]')
        || document.querySelector('[data-abcp-variants]');
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      if (this.moneyFormat) return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
      return '$' + value;
    }

    bindPills() {
      this.pills = Array.from(this.querySelectorAll('[data-pill]'));
      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.selectVariant(parseInt(pill.dataset.variant, 10)));
      });
    }

    selectVariant(id) {
      const v = this.variants.find((x) => x.id === id);
      if (!v) return;

      this.pills.forEach((p) => {
        const on = parseInt(p.dataset.variant, 10) === id;
        p.classList.toggle('is-selected', on);
        p.setAttribute('aria-pressed', String(on));
      });

      if (this.variantInput) this.variantInput.value = id;

      const set = (sel, txt) => { const e = this.querySelector(sel); if (e) e.textContent = txt; };
      set('[data-price]', v.price_money);
      const titleEl = this.querySelector('[data-variant-title]');
      if (titleEl) titleEl.textContent = v.title;

      const compareEl = this.querySelector('[data-compare]');
      const saveEl = this.querySelector('[data-save]');
      const hasCompare = v.compare && v.compare > v.price;
      if (compareEl) { compareEl.hidden = !hasCompare; compareEl.textContent = v.compare_money; }
      if (saveEl) { saveEl.hidden = !hasCompare; saveEl.textContent = 'Save ' + this.formatMoney(v.compare - v.price); }

      const stockEl = this.querySelector('[data-stock]');
      if (stockEl) stockEl.textContent = v.available ? (v.digital ? (window.abcpDigitalInStockLabel || 'In stock') : (window.abcpInStockLabel || 'In stock')) : 'Sold out';

      const instock = this.querySelector('[data-instock]');
      const outstock = this.querySelector('[data-outstock]');
      const buynow = this.querySelector('[data-buynow]');
      if (instock) instock.hidden = !v.available;
      if (buynow) buynow.hidden = !v.available;
      if (outstock) outstock.hidden = v.available;

      this.atcBaseCents = v.price;
      this.updateAtcPrice();

      if (v.media_id) this.switchMedia(v.media_id);
    }

    bindQty() {
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.atcBaseCents = parseInt(this.querySelector('[data-atc]')?.dataset.baseCents || '0', 10);
      this.querySelector('[data-qty-dec]')?.addEventListener('click', () => this.stepQty(-1));
      this.querySelector('[data-qty-inc]')?.addEventListener('click', () => this.stepQty(1));
      this.qtyInput?.addEventListener('change', () => this.updateAtcPrice());
    }

    stepQty(delta) {
      const next = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + delta);
      this.qtyInput.value = next;
      this.updateAtcPrice();
    }

    updateAtcPrice() {
      const priceEl = this.querySelector('[data-atc-price]');
      const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
      if (priceEl && this.atcBaseCents) priceEl.textContent = this.formatMoney(this.atcBaseCents * qty);
    }

    bindThumbs() {
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.mainImg = this.querySelector('[data-main] img');
      this.thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          this.setActiveThumb(t);
          if (this.mainImg && t.dataset.full) { this.mainImg.src = t.dataset.full; this.mainImg.srcset = ''; }
        });
      });
    }

    setActiveThumb(thumb) {
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
    }

    switchMedia(mediaId) {
      const t = this.thumbs.find((x) => x.dataset.mediaId === String(mediaId));
      if (!t) return;
      this.setActiveThumb(t);
      if (this.mainImg && t.dataset.full) { this.mainImg.src = t.dataset.full; this.mainImg.srcset = ''; }
    }

    bindShare() {
      const btn = this.querySelector('[data-share]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const url = window.location.href;
        const done = () => { const o = btn.textContent; btn.textContent = 'Link copied ✓'; setTimeout(() => { btn.textContent = o; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(done);
        else done();
      });
    }

    bindAddToCart() {
      this.atc = this.querySelector('[data-atc]');
      if (!this.atc) return;
      this.atc.addEventListener('click', () => {
        const id = this.variantInput ? this.variantInput.value : null;
        const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
        if (!id) return;
        const orig = this.atc.innerHTML;
        this.atc.disabled = true;
        this.atc.textContent = 'Adding…';
        fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then((r) => r.json())
          .then(() => {
            this.atc.textContent = 'Added ✓';
            const status = this.querySelector('[data-status]');
            if (status) status.textContent = 'Added to cart';
            return fetch((window.routes ? window.routes.cart_url : '/cart') + '.js');
          })
          .then((r) => r.json())
          .then((cart) => {
            document.querySelectorAll('[data-cart-count], .abc-cart-count').forEach((el) => { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => { this.atc.innerHTML = orig; this.atc.disabled = false; this.updateAtcPrice(); }, 1800);
          })
          .catch(() => { this.atc.textContent = 'Error — try again'; setTimeout(() => { this.atc.innerHTML = orig; this.atc.disabled = false; }, 2200); });
      });
    }
  }

  customElements.define('abc-product', AbcProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.abc-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var answerId = this.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);

      this.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        answer.hidden = true;
      } else {
        answer.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class ApexHeader extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-search-overlay]');
      // Move the search overlay out of the header's stacking context so it can
      // paint above the announcement bar / header group.
      if (this.overlay && this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }
      this.searchInput = this.overlay?.querySelector('[data-search-input]');
      this.searchOpenBtns = this.querySelectorAll('[data-search-open]');
      this.shop = this.querySelector('[data-shop]');
      this.shopTrigger = this.querySelector('[data-shop-trigger]');
      this.mobileToggle = this.querySelector('[data-mobile-toggle]');
      this.mobileMenu = this.querySelector('[data-mobile-menu]');

      this.searchOpenBtns.forEach((btn) => btn.addEventListener('click', () => {
        this.toggleMobile(false);
        this.toggleSearch(true);
      }));
      this.overlay?.querySelector('[data-search-close]')?.addEventListener('click', () => this.toggleSearch(false));

      this.shopTrigger?.addEventListener('click', () => this.toggleShop());
      this.mobileToggle?.addEventListener('click', () => this.toggleMobile());

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.overlay && !this.overlay.hidden) this.toggleSearch(false);
        this.toggleShop(false);
        this.toggleMobile(false);
      });

      // Close the Shop dropdown when focus or pointer leaves it.
      this.shop?.addEventListener('focusout', (e) => {
        if (!this.shop.contains(e.relatedTarget)) this.toggleShop(false);
      });
    }

    toggleSearch(open) {
      if (!this.overlay) return;
      this.overlay.hidden = !open;
      this.searchOpenBtn?.setAttribute('aria-expanded', String(open));
      if (open) {
        this.searchInput?.focus();
      } else {
        this.searchOpenBtn?.focus();
      }
    }

    toggleShop(force) {
      if (!this.shop) return;
      const open = force === undefined ? !this.shop.hasAttribute('open') : force;
      this.shop.toggleAttribute('open', open);
      this.shopTrigger?.setAttribute('aria-expanded', String(open));
    }

    toggleMobile(force) {
      if (!this.mobileMenu) return;
      const open = force === undefined ? this.mobileMenu.hidden : force;
      this.mobileMenu.hidden = !open;
      this.mobileToggle?.setAttribute('aria-expanded', String(open));
    }
  }

  customElements.define('apex-header', ApexHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kickstarter-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function update() {
      document.querySelectorAll('[data-ks-launch]').forEach(function (root) {
        var launch = parseInt(root.getAttribute('data-ks-launch'), 10) * 1000;
        var live = launch > 0 && Date.now() >= launch;
        root.querySelectorAll('[data-ks-state]').forEach(function (el) {
          el.hidden = (el.getAttribute('data-ks-state') === 'live') !== live;
        });
      });
    }
    update();
    setInterval(update, 30000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-archive"]) return;
  try {
    
  class ArchiveFilter extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.yearSel = this.querySelector('[data-year-filter]');
      this.search = this.querySelector('[data-search]');
      this.countEl = this.querySelector('[data-count]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.total = this.cards.length;
      var grid = this.querySelector('[data-grid]');
      if (grid) {
        var sortOverrides = { '2020': 120.5 };
        this.cards.sort(function (a, b) {
          var ai = sortOverrides[a.getAttribute('data-issue')] !== undefined ? sortOverrides[a.getAttribute('data-issue')] : parseInt(a.getAttribute('data-issue') || 0, 10);
          var bi = sortOverrides[b.getAttribute('data-issue')] !== undefined ? sortOverrides[b.getAttribute('data-issue')] : parseInt(b.getAttribute('data-issue') || 0, 10);
          return bi - ai;
        }).forEach(function (card) { grid.appendChild(card); });
      }
      var apply = this.apply.bind(this);
      this.yearSel && this.yearSel.addEventListener('change', apply);
      this.search && this.search.addEventListener('input', apply);
    }
    apply() {
      var year = this.yearSel ? this.yearSel.value : 'all';
      var q = (this.search ? this.search.value : '').trim().toLowerCase();
      var shown = 0;
      this.cards.forEach(function (card) {
        var okYear = year === 'all' || card.getAttribute('data-year') === year;
        var okQ = !q || (card.getAttribute('data-search') || '').indexOf(q) !== -1;
        var vis = okYear && okQ;
        card.style.display = vis ? '' : 'none';
        if (vis) shown++;
      });
      if (this.countEl) this.countEl.textContent = shown;
      if (this.emptyEl) this.emptyEl.hidden = shown !== 0;
    }
  }
  customElements.define('archive-filter', ArchiveFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-author-profile"]) return;
  try {
    
(function() {
  const container = document.getElementById('mag-author-profile');
  const authorsUrl = container.dataset.authorsUrl;
  const placeholderUrl = container.dataset.placeholderUrl;
  const urlParams = new URLSearchParams(window.location.search);
  const slug = urlParams.get('slug');

  async function loadAndRender() {
    if (!slug) {
      container.innerHTML = '<div class="mag-author-profile__container"><div class="mag-author-profile__error">Author not found.</div></div>';
      return;
    }

    try {
      const resp = await fetch(authorsUrl);
      const authors = await resp.json();
      const author = authors.find(a => a.slug === slug);

      if (!author) {
        container.innerHTML = '<div class="mag-author-profile__container"><div class="mag-author-profile__error">Author not found.</div></div>';
        return;
      }

      let html = '<div class="mag-author-profile__container">';
      html += '<div class="mag-author-profile__back"><a href="/pages/apex-magazine?view=apex-magazine-authors" class="mag-author-profile__back-link">← Back to all authors</a></div>';
      html += '<div class="mag-author-profile__header">';

      const photoSrc = author.photo_url || placeholderUrl;
      html += `<img src="${photoSrc}" alt="${author.name}" class="mag-author-profile__photo" loading="eager">`;

      html += '<div class="mag-author-profile__info">';
      html += `<h1>${author.name}</h1>`;
      html += `<div class="mag-author-profile__bio">${author.bio || 'No bio available.'}</div>`;

      if (Object.keys(author.socials || {}).length > 0) {
        html += '<div class="mag-author-profile__socials">';
        for (const [platform, url] of Object.entries(author.socials)) {
          const label = platform.charAt(0).toUpperCase() + platform.slice(1);
          html += `<a href="${url}" target="_blank" rel="noopener" class="mag-author-profile__social">${label} ↗</a>`;
        }
        html += '</div>';
      }

      html += '</div></div>';

      if (author.stories && author.stories.length > 0) {
        html += '<div class="mag-author-profile__stories">';
        html += `<h2 class="mag-author-profile__stories-title">Stories by ${author.firstname}</h2>`;
        html += '<ul class="mag-author-profile__stories-list">';
        author.stories.forEach(story => {
          const meta = [story.category, story.issue].filter(Boolean).join(' · ');
          html += `
            <li class="mag-author-profile__story">
              <div class="mag-author-profile__story-title">${story.title}</div>
              <div class="mag-author-profile__story-meta">${meta || 'Unknown'}</div>
              <div class="mag-author-profile__story-link">
                <a href="/blogs/apex-magazine/${story.slug}" class="mag-author-profile__story-link-text">Read →</a>
              </div>
            </li>
          `;
        });
        html += '</ul></div>';
      } else {
        html += '<div class="mag-author-profile__empty"><p>No published stories yet.</p></div>';
      }

      html += '</div>';
      container.innerHTML = html;
    } catch (e) {
      console.error('Failed to load author:', e);
      container.innerHTML = '<div class="mag-author-profile__container"><div class="mag-author-profile__error">Failed to load author data.</div></div>';
    }
  }

  loadAndRender();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-authors-directory"] && !Shopify.designMode) return;
  try {
    
(function() {
  const searchInput = document.getElementById('mag-authors-search');
  const sortSelect = document.getElementById('mag-authors-sort');
  const grid = document.getElementById('mag-authors-grid');
  const emptyMsg = document.getElementById('mag-authors-empty');
  const authorsUrl = grid.dataset.authorsUrl;
  const placeholderUrl = grid.dataset.placeholderUrl;
  let authorsData = [];

  // Load authors data
  async function loadAuthors() {
    try {
      const resp = await fetch(authorsUrl);
      authorsData = await resp.json();
      render();
    } catch (e) {
      console.error('Failed to load authors:', e);
    }
  }

  function render() {
    const query = searchInput.value.toLowerCase();
    const sortBy = sortSelect.value;

    let filtered = authorsData.filter(a =>
      a.story_count > 0 && (
        a.name.toLowerCase().includes(query) ||
        (a.bio && a.bio.toLowerCase().includes(query))
      )
    );

    // Sort
    if (sortBy === 'stories') {
      filtered.sort((a, b) => b.story_count - a.story_count);
    } else if (sortBy === 'recent') {
      filtered.sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
    } else {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    }

    // Render
    grid.innerHTML = '';
    if (filtered.length === 0) {
      emptyMsg.style.display = 'block';
      return;
    }
    emptyMsg.style.display = 'none';

    filtered.forEach(author => {
      const card = document.createElement('a');
      card.href = '/pages/apex-magazine?view=apex-magazine-author&slug=' + encodeURIComponent(author.slug);
      card.className = 'mag-author-card';
      card.innerHTML = `
        <img src="${author.photo_url || placeholderUrl}" alt="${author.name}" class="mag-author-photo" loading="lazy">
        <h3 class="mag-author-name">${author.name}</h3>
        ${author.bio ? `<p class="mag-author-bio">${author.bio}</p>` : ''}
        <div class="mag-author-stats">${author.story_count} ${author.story_count === 1 ? 'story' : 'stories'}</div>
      `;
      grid.appendChild(card);
    });
  }

  searchInput.addEventListener('input', render);
  sortSelect.addEventListener('change', render);
  loadAuthors();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-blog"] && !Shopify.designMode) return;
  try {
    
  class StoryFilter extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.search = this.querySelector('[data-search]');
      this.countEl = this.querySelector('[data-count]');
      this.emptyEl = this.querySelector('[data-empty]');
      var apply = this.apply.bind(this);
      this.search && this.search.addEventListener('input', apply);
    }
    apply() {
      var q = (this.search ? this.search.value : '').trim().toLowerCase();
      var shown = 0;
      this.cards.forEach(function (card) {
        var vis = !q || (card.getAttribute('data-search') || '').indexOf(q) !== -1;
        card.style.display = vis ? '' : 'none';
        if (vis) shown++;
      });
      if (this.countEl) this.countEl.textContent = shown;
      if (this.emptyEl) this.emptyEl.hidden = shown !== 0;
    }
  }
  customElements.define('story-filter', StoryFilter);

  // Archive browser: client-side search (issue/author/title) + content-type
  // pills over the full magazine story index (assets/apex-magazine-index.json).
  var ARCH_TYPES = {
    'short-fiction': 'Short Fiction', 'nonfiction': 'Nonfiction',
    'interviews': 'Interviews', 'editorial': 'Editorials', 'poetry': 'Poetry',
    'podcast': 'Audio Fiction', 'novel-excerpt': 'Novel Excerpt'
  };
  var ARCH_PAGE = 30;

  class MagazineArchive extends HTMLElement {
    connectedCallback() {
      this.listEl = this.querySelector('[data-arch-list]');
      this.searchEl = this.querySelector('[data-arch-search]');
      this.countEl = this.querySelector('[data-arch-count]');
      this.titleEl = this.querySelector('[data-arch-title]');
      this.emptyEl = this.querySelector('[data-arch-empty]');
      this.moreEl = this.querySelector('[data-arch-more]');
      this.pills = Array.prototype.slice.call(this.querySelectorAll('.apex-arch__pill'));
      this.base = this.getAttribute('data-base') || '/blogs/apex-magazine/tagged/';

      var t = this.getAttribute('data-type') || '';
      this.type = ARCH_TYPES[t] ? t : '';
      this.q = '';
      this.shown = ARCH_PAGE;
      this.items = [];

      var self = this;
      this.searchEl && this.searchEl.addEventListener('input', function () {
        self.q = self.searchEl.value.trim().toLowerCase();
        self.shown = ARCH_PAGE; self.render();
      });
      this.pills.forEach(function (p) {
        p.addEventListener('click', function () {
          self.type = p.getAttribute('data-type') || '';
          self.shown = ARCH_PAGE;
          // Reflect the filter in the URL for shareable links.
          var url = self.type ? self.base + self.type : self.base.replace(/\/tagged\/$/, '');
          try { history.replaceState(null, '', url); } catch (e) {}
          self.render();
        });
      });
      this.moreEl && this.moreEl.addEventListener('click', function () {
        self.shown += ARCH_PAGE; self.render();
      });

      var src = this.getAttribute('data-src');
      fetch(src).then(function (r) { return r.json(); }).then(function (data) {
        self.items = sortArchive(Array.isArray(data) ? data : []);
        self.render();
      }).catch(function () {
        if (self.emptyEl) { self.emptyEl.hidden = false; self.emptyEl.textContent = 'Could not load the archive.'; }
      });
    }

    filtered() {
      var type = this.type, q = this.q;
      return this.items.filter(function (it) {
        if (type && it.c !== type) return false;
        if (!q) return true;
        var hay = (it.t + ' ' + it.a + ' issue ' + it.i).toLowerCase();
        return hay.indexOf(q) !== -1;
      });
    }

    render() {
      // Active pill state
      var type = this.type;
      this.pills.forEach(function (p) {
        p.setAttribute('aria-pressed', (p.getAttribute('data-type') || '') === type ? 'true' : 'false');
      });
      // Heading
      if (this.titleEl) this.titleEl.textContent = type ? (ARCH_TYPES[type] || type) : 'All stories';

      var matches = this.filtered();
      if (this.countEl) this.countEl.textContent = matches.length;
      if (this.emptyEl) this.emptyEl.hidden = matches.length !== 0;

      var slice = matches.slice(0, this.shown);
      var html = '';
      for (var i = 0; i < slice.length; i++) {
        var it = slice[i];
        var typeLabel = ARCH_TYPES[it.c] || '';
        var meta = it.i ? ('Issue ' + esc(it.i)) : '';
        var by = it.a ? esc(it.a) : '';
        var byLine = by + (by && meta ? ' · ' : '') + meta;
        html += '<a class="apex-arch__item" href="/blogs/apex-magazine/' + encodeURIComponent(it.u) + '">'
          + '<span class="apex-arch__type">' + esc(typeLabel) + '</span>'
          + '<span class="apex-arch__title">' + esc(it.t) + '</span>'
          + '<span class="apex-arch__by">' + byLine + '</span>'
          + '</a>';
      }
      this.listEl.innerHTML = html;
      if (this.moreEl) this.moreEl.hidden = this.shown >= matches.length;
    }
  }
  function esc(s) {
    var d = document.createElement('span'); d.textContent = s == null ? '' : String(s); return d.innerHTML;
  }

  // Order the archive: newest issue first, then newest post date (it.d, an ISO
  // date) within an issue. Stories with no issue number come after every
  // issue, newest post first. Anything with no date sinks to the bottom of its
  // group and keeps the file's original order, so an index without dates still
  // lists the way it used to.
  function sortArchive(items) {
    return items.map(function (it, n) { return { it: it, n: n }; }).sort(function (a, b) {
      var ai = parseInt(a.it.i, 10), bi = parseInt(b.it.i, 10);
      var aNone = isNaN(ai), bNone = isNaN(bi);
      if (aNone !== bNone) return aNone ? 1 : -1;
      if (!aNone && ai !== bi) return bi - ai;
      var ad = a.it.d || '', bd = b.it.d || '';
      if (ad !== bd) return ad < bd ? 1 : -1;
      return a.n - b.n;
    }).map(function (x) { return x.it; });
  }
  customElements.define('magazine-archive', MagazineArchive);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var list = document.querySelector('[data-toc-list]');
    var more = document.querySelector('[data-toc-more]');
    if (!list || !more) return;

    var rows = Array.prototype.slice.call(list.querySelectorAll('.apex-mag__toc-row'));
    var pageSize = parseInt(list.getAttribute('data-page-size'), 10) || 6;
    if (rows.length <= pageSize) return;

    var shown = pageSize;

    function render() {
      rows.forEach(function (row, i) {
        row.hidden = i >= shown;
      });
      more.hidden = shown >= rows.length;
    }

    more.addEventListener('click', function () {
      shown += pageSize;
      render();
      // Move focus to the first newly revealed row for keyboard users.
      var firstNew = rows[shown - pageSize];
      if (firstNew) firstNew.setAttribute('tabindex', '-1'), firstNew.focus();
    });

    render();
  })();

  // Still Dripping — scheduled posts (title, author, date), closest first.
  (function () {
    var el = document.querySelector('[data-still-dripping]');
    if (!el) return;
    var src = el.getAttribute('data-src');
    var listEl = el.querySelector('[data-drip-list]');
    if (!src || !listEl) return;

    fetch(src).then(function (r) { return r.json(); }).then(function (items) {
      if (!Array.isArray(items)) return;
      var now = Date.now();
      var upcoming = items.filter(function (i) {
        var t = Date.parse(i.date);
        return !isNaN(t) && t > now;
      }).sort(function (a, b) { return Date.parse(a.date) - Date.parse(b.date); });
      if (!upcoming.length) return;

      var html = '';
      upcoming.forEach(function (i) {
        var d = new Date(i.date);
        var date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        var title = document.createElement('span'); title.textContent = i.title || '';
        var author = document.createElement('span'); author.textContent = i.author || '';
        html += '<div class="apex-mag__drip-row">'
          + '<span class="apex-mag__drip-title">' + title.innerHTML + '</span>'
          + '<span class="apex-mag__drip-author">' + author.innerHTML + '</span>'
          + '<span class="apex-mag__drip-date">' + date + '</span>'
          + '</div>';
      });
      listEl.innerHTML = html;
      el.hidden = false;
    }).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-story"]) return;
  try {
    
  (function () {
    var PAGE_SIZE = 8;

    function renderPage(others, page, list, pager) {
      var start = page * PAGE_SIZE;
      var pageItems = others.slice(start, start + PAGE_SIZE);
      var html = '';
      pageItems.forEach(function (s) {
        var meta = [s.category, s.issue].filter(Boolean).join(' · ');
        var title = document.createElement('span');
        title.textContent = s.title || s.slug;
        html += '<li class="apex-story__also-item"><a class="apex-story__also-link" href="/blogs/apex-magazine/'
          + encodeURIComponent(s.slug) + '"><span class="apex-story__also-title">' + title.innerHTML + '</span>'
          + (meta ? '<span class="apex-story__also-meta">' + meta + '</span>' : '') + '</a></li>';
      });
      list.innerHTML = html;

      var totalPages = Math.ceil(others.length / PAGE_SIZE);
      if (totalPages <= 1) { pager.hidden = true; return; }

      pager.hidden = false;
      pager.querySelector('[data-also-prev]').disabled = page === 0;
      pager.querySelector('[data-also-next]').disabled = page >= totalPages - 1;
      pager.querySelector('[data-also-page]').textContent = (page + 1) + ' / ' + totalPages;
    }

    function initAlso() {
      var el = document.querySelector('[data-also]');
      if (!el) return;
      var url = el.getAttribute('data-authors-url');
      var author = (el.getAttribute('data-author') || '').trim().toLowerCase();
      var current = (el.getAttribute('data-current') || '').split('/').pop();
      if (!url || !author) return;
      fetch(url).then(function (r) { return r.json(); }).then(function (authors) {
        var match = null;
        for (var i = 0; i < authors.length; i++) {
          if ((authors[i].name || '').trim().toLowerCase() === author) { match = authors[i]; break; }
        }
        if (!match) return;
        var photoEl = document.querySelector('[data-bio-photo]');
        if (photoEl && match.photo_url) { photoEl.src = match.photo_url; photoEl.hidden = false; }
        if (!match.stories) return;
        var others = match.stories.filter(function (s) { return s.slug && s.slug !== current; });
        if (!others.length) return;

        var list = el.querySelector('[data-also-list]');
        var pager = el.querySelector('[data-also-pager]');
        var page = 0;

        renderPage(others, page, list, pager);
        el.hidden = false;

        pager.querySelector('[data-also-prev]').addEventListener('click', function () {
          if (page > 0) { page--; renderPage(others, page, list, pager); }
        });
        pager.querySelector('[data-also-next]').addEventListener('click', function () {
          if ((page + 1) * PAGE_SIZE < others.length) { page++; renderPage(others, page, list, pager); }
        });
      }).catch(function () {});
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAlso);
    } else {
      initAlso();
    }
  })();

  (function () {
    var btn = document.querySelector('[data-top-btn]');
    if (!btn) return;
    var threshold = 400;
    function onScroll() {
      var past = window.scrollY > threshold;
      btn.hidden = false;
      btn.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  (function alignSidebar() {
    var sidebar = document.querySelector('.apex-story__sidebar');
    var body = document.querySelector('.apex-story__body');
    if (!sidebar || !body) return;
    function update() {
      var gridTop = sidebar.parentElement.getBoundingClientRect().top;
      var bodyTop = body.getBoundingClientRect().top;
      sidebar.style.setProperty('--sidebar-body-offset', Math.max(0, bodyTop - gridTop) + 'px');
    }
    if (document.readyState === 'complete') { update(); } else { window.addEventListener('load', update); }
    window.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class AbcShare extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[data-copy]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const url = this.dataset.url || window.location.href;
        const done = () => {
          const o = btn.textContent;
          btn.textContent = '✓';
          setTimeout(() => { btn.textContent = o; }, 1500);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(done);
        else done();
      });
    }
  }
  customElements.define('abc-share', AbcShare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-strip"]) return;
  try {
    
class ReviewStrip extends HTMLElement {
  connectedCallback() {
    if (this.loaded) return;
    this.loaded = true;

    const dataEl = this.querySelector('[data-review-data]');
    const quoteEl = this.querySelector('[data-review-quote]');
    const attrEl = this.querySelector('[data-review-attr]');
    const bookEl = this.querySelector('[data-review-book]');
    if (!dataEl || !quoteEl || !attrEl) return;

    let reviews;
    const raw = (dataEl.textContent || '').trim();
    if (!raw) {
      this.hidden = true;
      return;
    }
    try {
      reviews = JSON.parse(raw);
    } catch (e) {
      // Malformed or empty data: hide the strip rather than show a bare bar.
      this.hidden = true;
      return;
    }

    if (!Array.isArray(reviews) || reviews.length === 0) {
      this.hidden = true;
      return;
    }

    const pick = reviews[Math.floor(Math.random() * reviews.length)];
    const markEl = this.querySelector('.review-strip__mark');

    if (pick.quote) {
      quoteEl.textContent = pick.quote;
      attrEl.innerHTML = this.renderAttribution(pick);
      if (bookEl) bookEl.innerHTML = this.renderBook(pick);
    } else {
      // No quote (e.g. an awards row): lead with the book title in place of the
      // quote, drop the decorative quotation mark, and fold the book line into
      // the attribution so the title isn't repeated.
      if (markEl) markEl.style.display = 'none';
      quoteEl.innerHTML = this.renderBook(pick, false);
      quoteEl.classList.add('review-strip__quote--title');
      attrEl.innerHTML = this.renderAttribution(pick);
      if (bookEl) bookEl.remove();
    }

    this.querySelector('.review-strip__inner')?.setAttribute('data-ready', '');
  }

  renderAttribution(review) {
    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      }[c]));

    // Attribution reads: PUBLICATION — Reviewer, with the publication linked
    // when a URL exists. Falls back gracefully when either field is absent.
    const parts = [];
    if (review.publication) {
      parts.push(
        review.url
          ? `<a href="${esc(review.url)}" target="_blank" rel="noopener">${esc(review.publication)}</a>`
          : esc(review.publication)
      );
    }
    if (review.reviewer) parts.push(esc(review.reviewer));

    let html = parts.join('<span class="review-strip__sep" aria-hidden="true">—</span>');

    const badges = Array.isArray(review.badges) ? review.badges : [];
    for (const label of badges) {
      if (!label) continue;
      const star =
        label.toLowerCase() === 'starred review'
          ? '<span class="review-strip__badge-star" aria-hidden="true">★</span>'
          : '';
      html +=
        `<span class="review-strip__badge">${star}${esc(label)}</span>`;
    }

    return html;
  }

  renderBook(review, includeAuthor = true) {
    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      }[c]));

    if (!review.book) return '';
    const title = `<span class="review-strip__book-title">${esc(review.book)}</span>`;
    let titleHtml = title;
    if (review.product_url) {
      // Use a root-relative path so the link is domain-agnostic.
      let href = review.product_url;
      try {
        href = new URL(review.product_url).pathname;
      } catch (e) {
        /* not a full URL — use as-is */
      }
      // Tag the click so it's attributable in analytics. utm_content carries the
      // product handle so you can see which book was clicked, not just that the
      // strip was the source. Append with the right separator in case the URL
      // already has a query string.
      const handle = href.split('/').filter(Boolean).pop() || 'review';
      const utm =
        'utm_source=review_strip&utm_medium=homepage_hero&utm_campaign=critical_praise' +
        `&utm_content=${encodeURIComponent(handle)}`;
      href += (href.indexOf('?') === -1 ? '?' : '&') + utm;
      titleHtml = `<a class="review-strip__book-link" href="${esc(href)}">${title}</a>`;
    }
    let html = titleHtml;
    if (includeAuthor && review.author) html += ` by ${esc(review.author)}`;
    return html;
  }
}

if (!customElements.get('review-strip')) {
  customElements.define('review-strip', ReviewStrip);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-quick-help"] && !Shopify.designMode) return;
  try {
    
  class SupportHelp extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-modal]');
      this.lastFocus = null;
      this.querySelectorAll('[data-open-modal]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(btn));
      });
      if (!this.modal) return;
      this.querySelector('[data-modal-overlay]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-modal-close]')?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.modal.hidden) this.close();
      });
    }
    open(trigger) {
      if (!this.modal) return;
      this.lastFocus = trigger || document.activeElement;
      this.modal.hidden = false;
      const first = this.modal.querySelector('a, button');
      if (first) first.focus();
    }
    close() {
      if (!this.modal) return;
      this.modal.hidden = true;
      if (this.lastFocus) this.lastFocus.focus();
    }
  }
  customElements.define('support-help', SupportHelp);

  } catch(e) { console.error(e); }
})();
})();
